import { render, staticRenderFns } from "./WorkflowRun.vue?vue&type=template&id=f3c38402"
import script from "./WorkflowRun.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowRun.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports